import { createAsyncThunk } from '@reduxjs/toolkit'
import { deserialize, serialize } from '../utility/serialization'

import Axios from '../axios'
import { handleAPIError } from '../utility/actionHelper'

// THUNKS

export const createCommunityAccessEntry = createAsyncThunk(
  'accessEntry/createCommunityAccessEntry',
  async ({ communityId, accessEntryData }, { rejectWithValue }) => {
    try {
      const { data } = await requestCreateCommunityAccessEntry(communityId, accessEntryData)
      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

// API CALLS

const requestCreateCommunityAccessEntry = (communityId, accessEntryData) => {
  const requestUrl = `/api/v1/communities/${communityId}/access_entries`

  const data = new FormData()
  const serializedAccessEntryData = serialize(accessEntryData)
  Object.keys(serializedAccessEntryData)
    .forEach((key) => data.append(`access_entry[${key}]`, serializedAccessEntryData[key]))

  return Axios.post(requestUrl, data)
}
